const WebEnquiryTypes = {
  WEB_ENQUIRY_FETCH_START: "web_enquiry_fetch_start",
  WEB_ENQUIRY_FETCH_SUCCESS: "web_enquiry_fetch_success",
  WEB_ENQUIRY_FETCH_FAILURE: "web_enquiry_fetch_failure",
  WEB_ENQUIRY_FETCH_RESET_START: "web_enquiry_fetch_reset_start",
  WEB_ENQUIRY_FETCH_RESPONSE_CHANGED: "web_enquiry_fetch_changed",

  //*************************WEB ENQUIRY EXPORT START *********************//
  WEB_ENQUIRY_EXPORT_START: "web_enquiry_export_start",
  WEB_ENQUIRY_EXPORT_SUCCESS: "web_enquiry_export_success",
  WEB_ENQUIRY_EXPORT_FAILURE: "web_enquiry_export_failure",
  WEB_ENQUIRY_EXPORT_RESET_START: "web_enquiry_export_reset_start",
  WEB_ENQUIRY_EXPORT_CHANGED: "web_enquiry_export_changed",
};

export default WebEnquiryTypes;
